import { QuestionCircleOutlined } from "@ant-design/icons";
import { FlowNodeOutputItemType } from "@packages/flow-core/module/node/types";
import { Row, Tooltip } from "antd";
import styles from "./index.less";
import SourceHandle from "../../../SourceHandle";
import { FlowNodeOutputTypeEnum } from "@packages/flow-core/module/node/constants";

export type LabelProps = FlowNodeOutputItemType & {
  moduleId: string;
  outputKey: string;
  outputs: FlowNodeOutputItemType[];
};

export default function Label({ outputKey, ...item }: LabelProps) {
  const { description, label = "" } = item;

  return (
    <Row
      justify="end"
      align="middle"
      className={styles.container}
      style={{ position: "relative" }}
    >
      {description && (
        <Tooltip title={description}>
          <QuestionCircleOutlined className={styles.icon} />
        </Tooltip>
      )}
      <div className={styles.label}>{label}</div>
      {item.type === FlowNodeOutputTypeEnum.source && (
        <SourceHandle
          handleKey={outputKey}
          valueType={item.valueType}
          moduleId={item.moduleId}
        />
      )}
    </Row>
  );
}
